require('../../modules/es.array.iterator');
require('../../modules/es.object.to-string');
require('../../modules/es.weak-map');
var path = require('../../internals/path');

module.exports = path.WeakMap;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/es/weak-map/index.js
// module id = 1235
// module chunks = 1